export default __webpack_public_path__ + "static/media/logokey.cdd1df92.svg";